export type VuexContentActionNameList =
  | "BOOKMARKED_COURSES_REQUEST"
  | "COURSE_DETAILS_REQUEST"
  | "ORG_COURSES_REQUEST"
  | "TOGGLE_BOOKMARK"
  | "RECOMMENDED_COURSES_REQUEST";
export type VuexContentActionNames = {
  [T in VuexContentActionNameList]: string;
};

export type VuexContentMutationNameList =
  | "BOOKMARKED_COURSES"
  | "LOADING_BOOKMARKED_COURSES"
  | "COURSE_DETAILS"
  | "ORG_COURSES"
  | "RECOMMENDED_COURSES"
  | "LOADING_RECOMMENDED_COURSES";
export type VuexContentMutationNames = {
  [T in VuexContentMutationNameList]: string;
};

export const VUEX_CONTENT_NAMESPACE = "content";

export const VUEX_CONTENT_ACTION_NAMES: VuexContentActionNames = {
  BOOKMARKED_COURSES_REQUEST: "bookmarked_courses_request",
  COURSE_DETAILS_REQUEST: "course_details_request",
  ORG_COURSES_REQUEST: "org_courses_request",
  TOGGLE_BOOKMARK: "toggle_bookmark",
  RECOMMENDED_COURSES_REQUEST: "recommended_courses_request"
};

export const VUEX_CONTENT_MUTATION_NAMES: VuexContentMutationNames = {
  BOOKMARKED_COURSES: "bookmarked_courses",
  LOADING_BOOKMARKED_COURSES: "loading_bookmarked_courses",
  COURSE_DETAILS: "course_details",
  ORG_COURSES: "org_courses",
  RECOMMENDED_COURSES: "recommended_courses",
  LOADING_RECOMMENDED_COURSES: "loading_recommended_courses"
};
